/**
 * Report export helpers — CSV (opens in Excel), PDF (via browser print dialog),
 * and plain Print. Keeps things dependency-free.
 */

// --- CSV ---
function _csvCell(v) {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCSV(filename, columns, rows) {
  // columns: [{key, label}] ; rows: [{...}]
  const header = columns.map((c) => _csvCell(c.label)).join(",");
  const body = rows
    .map((r) => columns.map((c) => _csvCell(typeof c.get === "function" ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  const csv = `${header}\n${body}`;
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// --- Print / PDF ---
// Both call window.print(); users choose "Save as PDF" in the print dialog for PDF.
export function printReport(rootId) {
  // If a root id is provided, add a body class so print CSS shows only that node.
  if (rootId) {
    document.body.classList.add("printing-report");
    document.body.setAttribute("data-print-root", rootId);
  }
  const cleanup = () => {
    document.body.classList.remove("printing-report");
    document.body.removeAttribute("data-print-root");
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  // Give React a tick to apply the class before the browser snapshots the page
  setTimeout(() => window.print(), 50);
}
